<template>
  <span
    class="dot"
    :style="{
      width: size + 'px',
      height: size + 'px',
      background: meta.dot,
    }"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { statusMetaFor } from "./statusMeta";

const props = withDefaults(
  defineProps<{ status: string; size?: number }>(),
  { size: 8 }
);

const meta = computed(() => statusMetaFor(props.status));
</script>

<style scoped>
.dot {
  display: inline-block;
  border-radius: 50%;
  flex-shrink: 0;
}
</style>
